import React from 'react';
import AqiApp from './AqiApp';
import * as ReactDOMClient from 'react-dom/client';
// import './i18n';
import 'common-ui/lib/styles/index.scss';
import 'common-ui/lib/assets/css/style.css';
import { Provider } from 'react-redux';
import { applyMiddleware, compose } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { reducers } from './reducers';
import thunk from 'redux-thunk';
// import { Amplify } from 'aws-amplify';
// import awsmobile from './aws-exports';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import sessionStorage from 'redux-persist/lib/storage/session'
import reportWebVitals from './reportWebVitals';

// Amplify.configure(awsmobile);

const persistConfig = {
  key: 'root',
  storage: sessionStorage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const middleware = applyMiddleware(thunk);
const composeWithDevTools =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composedMiddleWare = composeWithDevTools(middleware)

// const store = configureStore(
//   { reducer: persistedReducer },
//   compose(
//     applyMiddleware(thunk),
//     window.devToolsExtension ? window.devToolsExtension() : f => f
//   )
// )

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
  devTools: window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
})
const persistor = persistStore(store);


const root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AqiApp />
    </PersistGate>
  </Provider>,
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
